/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backgrid = require('backgrid');

var tmplListCell = require('./ListCell.hbs');

module.exports = Backgrid.ListCell = Backgrid.Cell.extend({
  className: 'list-cell',

  render: function() {
    var cellValue = this.model.get(this.column.get('name'));
    var template = this.column.get('listTemplate') ? this.column.get('listTemplate') : tmplListCell;
    var emptyText = this.column.get('emptyText') ? this.column.get('emptyText') : '--';
    var content = template({
      values: cellValue,
      emptyText: emptyText
    });
    this.$el.empty().append(content);
    this.$el.addClass(this.column.get('name'));
    this.delegateEvents();
    return this;
  }
});
